import React from 'react'
import './AddInputButton.css'
interface AddInputButtonProps {
    onClick?: () => void
    className?: string
    disabled?: boolean
}
const AddInputButton: React.FC<AddInputButtonProps> = (props) => {
    const { onClick = () => undefined, className = '', disabled } = props
    return (
        <p
            className={`add-button ${className} ${disabled ? 'disable' : ''}`}
            onClick={() => {
                if (!disabled) onClick()
            }}
        >
            +
        </p>
    )
}

export default AddInputButton
